"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _GlobalNav = require("./GlobalNav.styles");

var _lettermark = _interopRequireDefault(require("../../assets/icons/lettermark.svg"));

var _elements = require("../../styles/elements");

var _MenuButton = _interopRequireDefault(require("./MenuButton/MenuButton"));

var _GlobalNavItem = _interopRequireDefault(require("./GlobalNavItem/GlobalNavItem"));

var _UserItem = _interopRequireDefault(require("./UserItem/UserItem"));

var GlobalNav = function GlobalNav(_ref) {
  var className = _ref.className,
      logo = _ref.logo,
      logoStyles = _ref.logoStyles,
      children = _ref.children,
      doToggleLeftSidebar = _ref.doToggleLeftSidebar,
      isLeftSidebarCollapsed = _ref.isLeftSidebarCollapsed,
      onClickMenuButton = _ref.onClickMenuButton,
      metaNav = _ref.metaNav,
      dataTestId = _ref.dataTestId;
  return (0, _jsxRuntime.jsxs)("nav", {
    css: _GlobalNav.styles.base,
    className: className,
    "data-test-id": dataTestId,
    children: [(0, _jsxRuntime.jsx)("div", {
      css: [_GlobalNav.styles.logo, logoStyles, process.env.NODE_ENV === "production" ? "" : ";label:GlobalNav;"],
      children: (0, _jsxRuntime.jsx)("img", {
        src: logo,
        alt: "logo"
      })
    }), (0, _jsxRuntime.jsx)("div", {
      css: _elements.divider.styles.base,
      role: "separator"
    }), (0, _jsxRuntime.jsxs)("div", {
      css: _GlobalNav.styles.scrollingContainer,
      children: [(0, _jsxRuntime.jsx)(_MenuButton["default"], {
        onClick: onClickMenuButton,
        doToggleLeftSidebar: doToggleLeftSidebar,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed
      }), (0, _jsxRuntime.jsx)("div", {
        css: _elements.divider.styles.base,
        role: "separator"
      }), children]
    }), metaNav && (0, _jsxRuntime.jsx)("div", {
      className: "grui flex flex-col items-center",
      children: metaNav
    })]
  });
};

GlobalNav.propTypes = {
  className: _propTypes.string,
  logo: _propTypes.string,
  logoStyles: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({
    name: _propTypes.string,
    styles: _propTypes.string
  }), _propTypes.func]),
  children: _propTypes.node,
  doToggleLeftSidebar: _propTypes.func,
  isLeftSidebarCollapsed: _propTypes.bool,
  onClickMenuButton: _propTypes.func,
  metaNav: _propTypes.node,
  dataTestId: _propTypes.string
};
GlobalNav.defaultProps = {
  className: undefined,
  logo: _lettermark["default"],
  logoStyles: undefined,
  children: undefined,
  doToggleLeftSidebar: _propTypes.func,
  isLeftSidebarCollapsed: false,
  onClickMenuButton: function onClickMenuButton() {},
  metaNav: undefined,
  dataTestId: 'GlobalNav'
};
GlobalNav.Item = _GlobalNavItem["default"];
GlobalNav.UserItem = _UserItem["default"];
var _default = GlobalNav;
exports["default"] = _default;
//# sourceMappingURL=GlobalNav.js.map